import { render, staticRenderFns } from "./juyi-project-list.vue?vue&type=template&id=15a3ce06&scoped=true"
import script from "./juyi-project-list.vue?vue&type=script&lang=js"
export * from "./juyi-project-list.vue?vue&type=script&lang=js"
import style0 from "./juyi-project-list.vue?vue&type=style&index=0&id=15a3ce06&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a3ce06",
  null
  
)

export default component.exports